import {Injectable} from '@angular/core';
import {FilterOption} from "../interface/filter-option";
import {FilterKey} from "../interface/filter-key";
import {FilterRangeOption} from "../interface/filter-range-option";
import {FilterCsvMetadataService} from "./filter-csv-metadata.service";
import {ProductMetadataInfo} from "../interface/product-metadata-info";
import {FilterControl} from "../interface/filter-control";
import {FilterControlOption} from "../interface/filter-control-option";
import {filter} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class FilterResultService {

	constructor(
		private _metadataApi: FilterCsvMetadataService
	) {
	}

	public getFilterControlsFromKey(
		key: FilterKey,
		control: FilterControl
	): FilterControlOption[] {
		const controls: FilterControlOption[] = [];

		if(!control.cohort) {
			return [];
		}

		control.cohort.options.forEach(option => {
			if (option.active && key.type !== 'sub') {
				controls.push({
					name: control.title,
					type: key.type,
					option: option,
				});
			}
			else if (option.subOptions && option.subOptions.length > 0) {
				option.subOptions.forEach(subOpt => {
					if(subOpt.active) {
						controls.push({
							name: control.title,
							type: key.type,
							option: subOpt,
							mainOption: option
						});
					}
				});
			}
		})
		return controls;
	}


	public getFilterValuesFromKey(
		key: FilterKey,
		options: FilterOption[]
	): string[] {
		const values: string[] = [];

		options.forEach(option => {
			if (option.active && key.type !== 'sub') {
				values.push(option.value);
			}
			else if (option.subOptions && option.subOptions.length > 0) {
				option.subOptions.forEach(subOpt => {
					if(subOpt.active) {
						values.push(subOpt.value);
					}
				});
			}
		})
		return values;
	}

	public geFilterValuesFromSubCategoryControls(subCategoryControls: FilterOption[]): string[] {
		let values: string[] = [];

		subCategoryControls.forEach((controls) => {
			if (controls.active) {
				values.push(controls.value)
			}
		})

		return values;
	}

	public getFilterValuesFromCsv(
		options: FilterOption[],
		metadataList: ProductMetadataInfo[]
	): string[] {
		const values: string[] = [];
		options.forEach((option: FilterOption) => {
			if (option.active) {
				const csvValueName: string | undefined = metadataList
					.find(metadata => metadata.id === +option.value)?.name;
				if(csvValueName)
					values.push(csvValueName);
			}
		});

		return values;
	}

	public getFilterValuesFromRange(option: FilterRangeOption): string[] {
		let values: string[] = [];

		if (option.value1 || option.defaultMax === option.value2) {
			values = [];
		}
		if (option.defaultMin < option.value1 || option.defaultMax > option.value2) {
			values = ['min-' + option.value1, 'max-' + option.value2];
		}
		return values;

	}

}
